import SerialItem from './serial-item';

export default class SerialInfo {
	sku: string;
	productName: string;
	productId: number;
	qty: number;
	serials: Array<SerialItem>;
  }
 